import { usePage } from "@inertiajs/react";

import LegalPage from "../_kit/LegalPage";
import {
  useLandingLanguage,
  LandingLanguageProvider,
} from "../../../contexts/landing-language";

const PrivacyPolicyContent = () => {
  const { privacy_policy: privacyPolicy } = usePage().props;
  const { t } = useLandingLanguage();

  return <LegalPage document={privacyPolicy} fallback={t.privacyPolicy} />;
};

const PrivacyPolicy = () => (
  <LandingLanguageProvider>
    <PrivacyPolicyContent />
  </LandingLanguageProvider>
);

export default PrivacyPolicy;
